import EDC from '../../../shared/globals';

EDC.Animations.QuestionMark = function (scene) {
  this.scene = scene;
  this.marks = [];
  this.redMark = null;
  this.currentRedIdx = 0;
};

EDC.Animations.QuestionMark.prototype.create = function () {
  const data = [
    { x: 552, y: 510, angle: -90 },
    { x: 650, y: 125, angle: -45 },
    { x: 1181, y: 110, angle: 0 },
    { x: 1687, y: 135, angle: 45 },
    { x: 1753, y: 533, angle: 75 },
  ];
  for (let i = 0; i < data.length; i++) {
    this.addMark(data[i].x, data[i].y, data[i].angle);
  }
  this.redMark = this.scene.add.sprite(0, 0, 'question-mark-red');
  this.redMark.setAlpha(0);
  return this;
};

EDC.Animations.QuestionMark.prototype.addMark = function (x, y, angle) {
  const mark = this.scene.add.sprite(x, y, 'question-mark');
  mark.setAngle(angle);
  this.marks.push(mark);
};

EDC.Animations.QuestionMark.prototype.start = function () {
  this.showMark();
};

EDC.Animations.QuestionMark.prototype.showMark = function () {
  const { x } = this.marks[this.currentRedIdx];
  const { y } = this.marks[this.currentRedIdx];
  const { angle } = this.marks[this.currentRedIdx];
  this.redMark.setPosition(x, y);
  this.redMark.setAngle(angle);
  this.scene.tweens.add({
    targets: this.redMark,
    alpha: 1,
    duration: 800,
    ease: 'Linear',
    onComplete: function () {
      this.scene.time.addEvent({ delay: 500, callback: this.hideMark, callbackScope: this });
    }.bind(this),
  });
};

EDC.Animations.QuestionMark.prototype.hideMark = function () {
  this.scene.tweens.add({
    targets: this.redMark,
    alpha: 0,
    duration: 1000,
    ease: 'Sine.easeInOut',
    onComplete: function () {
      this.currentRedIdx += 1;
      if (this.currentRedIdx >= this.marks.length) {
        this.currentRedIdx = 0;
      }
      this.showMark();
    }.bind(this),
  });
};

export default EDC.Animations.QuestionMark;
